import { render } from "./PartnerUsersListItem.vue?vue&type=template&id=48a5e2a0"
import script from "./PartnerUsersListItem.vue?vue&type=script&lang=js"
export * from "./PartnerUsersListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__